/**
 * Convert a base64URL string to an ArrayBuffer
 */
export function base64URLStringToBuffer(base64URLString: string): ArrayBuffer {
  // Convert from base64URL to base64
  const base64 = base64URLString.replace(/-/g, '+').replace(/_/g, '/');
  const paddedBase64 = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
  
  // Convert base64 to binary string
  const binaryString = atob(paddedBase64);
  
  // Convert binary string to buffer
  const buffer = new ArrayBuffer(binaryString.length);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < binaryString.length; i++) {
    view[i] = binaryString.charCodeAt(i);
  }
  return buffer;
}

/**
 * Convert an ArrayBuffer to a base64URL string
 */
export function bufferToBase64URLString(buffer: ArrayBuffer): string {
  // Convert buffer to binary string
  const view = new Uint8Array(buffer);
  let binaryString = '';
  for (let i = 0; i < view.length; i++) {
    binaryString += String.fromCharCode(view[i]);
  }
  
  // Convert binary string to base64
  const base64 = btoa(binaryString);
  
  // Convert base64 to base64URL
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
} 